import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 16831 25948"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M2140 4979c-231-338-356-734-356-1142 0-1132 921-2053 2053-2053s2053 921 2053 2053c0 252-47 504-138 739-197-478-375-856-530-1127-131-602-719-1061-1385-1061-799 0-1449 650-1449 1449 0 20 1 39 3 58-145 322-229 685-251 1084z"
        className="fil0"
      />
      <path
        d="M2537 7442C1012 6896 0 5471 0 3837 0 1721 1721 0 3837 0c2115 0 3837 1721 3837 3837 0 1040-425 2036-1172 2757-76-219-151-433-226-642 512-589 793-1338 793-2115 0-1783-1449-3233-3232-3233S604 2054 604 3837c0 1202 691 2325 1764 2875l169 730z"
        className="fil0"
      />
      <path
        d="M991 19513c-316-736-551-5838 5-6394 351-352 1622 96 1960 724 571 1063 136 1948 573 3101 420 1105 1129 855 1479-347 0 0 85-1476-29-1951-191-798-1443-6124-2010-8602-500-2187 980-3032 1447-2488 995 1160 3576 10393 3576 10393l-455-2619c0-940 2442-477 2737 176l701 2443s-279-1608-279-2324c0-400 1866 32 2345 692 329 451 918 1632 918 1632s-461-1471-399-1567c143-221 1660 551 2152 1275 1593 2347 1136 4979 728 7816-293 2034-1387 3450-1985 4090-230 245-551 385-887 385H7329c-312 0-591-144-837-335-2375-1844-4347-3421-5501-6100z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
